import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { CreateConversationWithAdminParams } from './request';
import { createConversationWithAdmin } from './request';

export const useCreateConversationWithAdminMutation = (
  settings?: MutationSettings<
    CreateConversationWithAdminParams,
    typeof createConversationWithAdmin
  >
) =>
  useMutation({
    mutationKey: ['createConversationWithAdmin'],
    mutationFn: ({ params, config }) =>
      createConversationWithAdmin({ params, config }),
    ...settings?.options
  });
